export default {"src":"/_next/static/media/patyna_logo.712907f7.svg","height":181,"width":145,"blurWidth":0,"blurHeight":0};